import ImageWithFallback from "components/ImageWithFallback";
import Rating from "components/Rating";
import React, {useEffect, useState} from "react";
import Link from "next/link";
import calcOpenNow from "lib/utils/calcOpenNow";
import cn from "clsx";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "@mui/material";
import RoundButton from "components/RoundButton";
import _ from "lodash";
import {DateTime} from "luxon";
import {isValidEmail} from "../../utils/helper";

export default function MapDetailCard({data: location, className, row=false, onMouseEnter=()=>{}, t, i18n, isMobile}) {
    const [openNow, setOpenNow] = useState(undefined)
    const [hoursToday, setHoursToday] = useState('')
    const [hasSNS, setHasSNS] = useState(false)
    const [validSNS, setValidSNS] = useState([])

    useEffect(() => {
        console.log('location: ', location)
        const {isOpen, openTime, closeTime} = calcOpenNow(location.business_hours, location.timezone)
        setOpenNow(isOpen)
        setHoursToday(`${openTime} - ${closeTime}`)
        for (let sns in location.social) {
            console.log('sns: ', location.social[sns])
            if (location.social[sns] !== "SocialIDs" && location.social[sns] !== '') {
                setHasSNS(true)
                setValidSNS(oldSNS =>[...oldSNS, location.social[sns]])
            }
        }
    }, [])

    useEffect(() => {
        console.log('validSNSss: ', validSNS)
    }, [validSNS])

    return (
        <div onMouseEnter={onMouseEnter} className={'flex flex-col items-center'}>
            <div className={isMobile ? cn('flex flex-col', className) : cn(row&&'flex', className)}>
                <Link href={`/stores/${location.slug}/${location.id}` } passHref>
                    <div className={isMobile ? cn(["relative after:content-[''] after:block items-center self-center", row?'after:pb-[100%] w-32':'after:pb-[56.25%] mb-4']) : cn(["relative after:content-[''] after:block", row?'after:pb-[100%] w-32':'after:pb-[56.25%] mb-4'])}>
                        <ImageWithFallback
                            src={location.avatar_url}
                            alt={location.name}
                            className="object-contain transition hover:brightness-105 cursor-pointer"
                        />
                    </div>
                </Link>
                <div className="px-4">
                    <Link href={`/stores/${location.slug}/${location.id}`} passHref>
                        <a>
                            <h4 className="font-bold text-base mb-2">
                                {location.name}
                            </h4>
                        </a>
                    </Link>
                    <div className="flex flex-nowrap items-center mb-2">
                        <div className="text-xs mr-2">
                            {location.rating.toFixed(1)}
                        </div>
                        <Rating
                            value={location.rating || 5}
                            precision={0.5}
                            readOnly
                            className={'mr-2'}
                        />
                        <div className="text-xs">
                            ({location.reviews_count})
                        </div>
                    </div>
                    {
                        location.has_curbside_pickup &&
                        <div className="text-sm text-primary-dark font-semibold mb-1">
                            {t('home:map_pickupAvailable')}
                        </div>
                    }
                    <div className="text-sm mb-1">
                        {openNow}
                    </div>
                    <div className="text-sm">
                        {location.distance.toFixed(1)}km
                    </div>
                </div>
            </div>
            <div className={cn(['flex flex-row justify-between align-center w-full mt-2'], className)}>
                <RoundButton disabled={!location.phone_number} icon={'phone'} name={t('home:map_call')} clickEvent={() => {
                    if (!!location.phone_number) {
                        window.open(`tel:${location.phone_number}`)
                    }
                }}  />
                <RoundButton disabled={!isValidEmail(location.email)}icon={'envelope'} name={t('home:map_email')} clickEvent={() => {
                    if (isValidEmail(location.email)) {
                        window.open(`mailto:${location.email}`)
                    }
                }} />
                <RoundButton disabled={!hasSNS} icon={'add'} name={t('home:map_follow')}  clickEvent={() => {
                    if (hasSNS) {
                        window.open(validSNS[1], '_blank')
                    }
                }} />
                <RoundButton disabled={true} icon={'star'} name={t('home:map_review')}  />
                <RoundButton disabled={true} icon={'share'} name={t('home:map_share')}  />

            </div>
            <div className={cn(['w-full'], className)}>
                <Link href={`/stores/${location.slug}/${location.id}`} passHref>
                    <Button className={'border-2 border-[#DDDDDD] border-solid w-full text-[#7C7C7C] hover:text-black'}>
                    <span className={'text-sm'}>
                        {t('home:map_viewMenu')}
                    </span>
                    </Button>
                </Link>
            </div>
            <div className={cn(['w-full'], className)}>
                <span className={'text-sm font-bold'}>{t('home:map_hoursOfOperation')}</span>
                <section className="flex items-start gap-3 mb-4">
                    <FontAwesomeIcon className={'w-7 text-xl text-gray-500 translate-y-0.5'} icon={solid('clock')}/>
                    <div>
                        <div className={'mb-1'}>
                            <div className="inline-block mr-4 w-28 font-bold text-primary-dark">
                                {openNow ? t('home:openNow') : t('home:map_detail_closed')}
                            </div>
                            {hoursToday}
                        </div>
                        {
                            ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => {
                                return (
                                    location.business_hours && location.business_hours.hasOwnProperty(day) &&
                                    <div key={day} className={'mb-1'}>
                                        <div className="inline-block mr-4 w-28">
                                            {_.capitalize(day)}
                                        </div>
                                        {DateTime.fromFormat(location.business_hours[day].open, 'hh:mma').toFormat('hh:mm a').toUpperCase()}
                                        {' - '}
                                        {DateTime.fromFormat(location.business_hours[day].close, 'hh:mma').toFormat('hh:mm a').toUpperCase()}
                                    </div>
                                )
                            })
                        }
                    </div>
                </section>
            </div>
        </div>
    )
}
